<ng-container [ngSwitch]="renderAs">

  <button
    *ngSwitchCase="'button'"
    [type]="type"
    [disabled]="disabled"
    [ngClass]="classes"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>

  <a
    *ngSwitchCase="'a'"
    [href]="href"
    [attr.aria-disabled]="disabled"
    [ngClass]="classes"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>

</ng-container>

<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>